import { useEffect, useMemo } from "react"
import { proxy, subscribe } from "valtio"

export function usePersistStore<T extends object>(key: string, maxAge: number, init: (data: Partial<T>) => T): T {
  const storageKey = "store_" + key
  const store = useMemo(() => {
    if (env.client) {
      try {
        let initial = JSON.parse(localStorage.getItem(storageKey)!) as null | (T & { __expires: number })
        if (initial && initial.__expires < new Date().getTime()) {
          initial = null as any
        }
        if (initial) return proxy(init(initial))
      } catch (err) {
        console.warn("Error loading store", err)
      }
    }
    return proxy(init({}))
  }, [key])

  useEffect(() => {
    return subscribe(store, () => {
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          ...store,
          __expires: new Date().getTime() + maxAge * 1000,
        })
      )
    })
  }, [store])

  return store
}
